/* eslint-disable no-magic-numbers */
/* eslint-disable react/jsx-pascal-case */
/** @jsx jsx */
import { jsx, Themed, useThemeUI } from 'theme-ui'
import React, { Fragment } from 'react'
import { Link, Col, Row } from '../helpers/react'
import Pagination from './pagination'
import { useDataSelector, useComponentMeta } from '../helpers/selectors'
import loadable from '@loadable/component'
import {
  cardVariantsMap,
  NO_PAGINATE_VARIANTS,
  CAROUSEL_VARIANTS,
} from '../../utils/category-guides-variants'
import { path } from '../../utils/obj'
import CategoryGuideCard from './category-guide-card'
import { useCategoryGuides } from './use-category-guides'
import { categoryGuidesStylePath } from './index'

const Carousel = loadable(() => import('./carousel'))

const DefaultCategoryGuides = ({
  variant,
  className = '',
  guides = [],
  layout,
  title,
  numberOfGuides,
  sys = {},
  showDate,
  showViewAll,
  showPagination = true,
  brand,
}) => {
  const { href } = useDataSelector(['url'])
  const { pathname, searchParams } = new URL(href)
  const filteredGuides = useCategoryGuides({ guides, pathname })
  const { total } = sys
  const limit = useDataSelector(['meta', 'paginationLimit'], 12)

  const { theme } = useThemeUI()
  const guideCardMeta = useComponentMeta('guideCard')
  const cardVariant = cardVariantsMap[variant] || guideCardMeta.variant
  const itemsPerRow =
    path(['compounds', 'card', 'variants', cardVariant, 'itemsPerRow'], theme) ||
    path(['compounds', 'card', 'itemsPerRow'], theme)
  const [colsMobile, colsTablet, colsDesktop] = guideCardMeta?.carouselColumns || [2, 2, 2]
  const isDefault = layout ? layout === 'default' : !NO_PAGINATE_VARIANTS.includes(variant)
  const isCarousel = CAROUSEL_VARIANTS.includes(variant) || layout === 'carousel'

  const queryPage = searchParams.get('page') || ''
  const showingAllGuides = queryPage === '-1'
  const paginationLimit = Math.min(numberOfGuides, limit) || limit

  const styles = {
    variant: categoryGuidesStylePath('title'),
    ...(brand === 'confused'
      ? { fontSize: '42px !important', fontWeight: '600' }
      : { color: 'dark-2' }),
  }

  return (
    <Fragment>
      <If condition={title}>
        <Themed.h3 sx={styles} className={className}>
          {title}
        </Themed.h3>
      </If>
      <Choose>
        <When condition={isCarousel}>
          <Carousel
            sys={sys}
            colsDesktop={colsDesktop}
            colsMobile={colsMobile}
            colsTablet={colsTablet}
            categoryGuides={filteredGuides}
            variant={cardVariant}
            showDate={showDate}
            showSimpleCard={showingAllGuides}
          >
            <For index='key' each='url' of={filteredGuides}>
              <CategoryGuideCard
                guide={url}
                variant={cardVariant}
                showDate={showDate}
                showSimpleCard={showingAllGuides}
              />
            </For>
          </Carousel>
        </When>
        <Otherwise>
          <Row cols={itemsPerRow} wrap>
            <For index='key' each='url' of={filteredGuides}>
              <Col span={1} key={key} sx={{ variant: categoryGuidesStylePath('column') }}>
                <CategoryGuideCard
                  guide={url}
                  variant={cardVariant}
                  showDate={showDate}
                  showSimpleCard={showingAllGuides}
                />
              </Col>
            </For>
          </Row>
        </Otherwise>
      </Choose>

      <If condition={total && isDefault && !showingAllGuides}>
        <div sx={{ display: 'flex', justifyContent: 'center', my: 'sm' }}>
          <If condition={showPagination}>
            <Pagination total={total} limit={paginationLimit} />
          </If>

          <If condition={showViewAll && total > paginationLimit}>
            <Link href={`${pathname}?page=-1`} sx={{ margin: 'auto 0', color: 'grey-80' }}>
              View All
            </Link>
          </If>
        </div>
      </If>
    </Fragment>
  )
}

export default DefaultCategoryGuides
